import type { CompanyType, FundraisingStage, Probability } from './types';

export function fundraisingStageLabel(stage: FundraisingStage): string {
  switch (stage) {
    case 'Mapeados':
      return 'Mapped';
    case 'Contactados':
      return 'Contacted';
    case 'Envío Info Principal':
      return 'Portal Access Sent';
    case '1ra Reunión':
      return '1st Meeting';
    case 'Interesados en continuar':
      return 'Interested';
    case 'Envio Data Room':
      return 'Sent Data Room';
    case 'En Negociación':
      return 'Negotiation';
    case 'En Term Sheet':
      return 'Term Sheet';
    case 'Ganado':
      return 'Won';
    case 'Proceso Abandonado':
      return 'Dropped';
    default:
      return stage;
  }
}

export function probabilityLabel(p: Probability): string {
  switch (p) {
    case 'Bajo':
      return 'Low';
    case 'Medio':
      return 'Medium';
    case 'Alto':
      return 'High';
    default:
      return p;
  }
}

export function companyTypeLabel(t: CompanyType): string {
  switch (t) {
    case 'Fondo':
      return 'Fund';
    case 'VC':
      return 'VC';
    case 'Angel':
      return 'Angel';
    case 'Otro':
      return 'Other';
    default:
      return t;
  }
}
